import * as TyreOfferModels from '../../models/tyre-offer/tyre-offer';
import { TyreOfferSearchModel } from '../../models/tyre-offer/tyre-offerSearch';
import * as Models from '../../models/commonModels';


export class GetList {
  static readonly type = '[TyreOffer] List';
  constructor(public Search: TyreOfferSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreOffer] Set Search';
  constructor(public Search: TyreOfferSearchModel) {}
}

export class ResetSearch {
  static readonly type = '[TyreOffer] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreOffer] Set List Page';
  constructor(public Search: TyreOfferSearchModel) { }
}

export class Insert {
  static readonly type = '[TyreOffer] Insert';
  constructor(public Invoice: TyreOfferModels.TyreOfferModel, public Version: number) { }
}

export class GetFilteredReport {
  static readonly type = '[TyreOffer] GetFilteredReport';
  constructor(public Search: TyreOfferSearchModel) { }
}

export class Refresh {
  static readonly type = '[TyreOffer] Refresh';
  constructor(public TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) { }
}

export class Set {
  static readonly type = '[TyreOffer] Set';
  constructor(public TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) { }
}

export class Assign {
  static readonly type = '[TyreOffer] Assign';
  constructor(public TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) { }
}

export class DisposeSearch {
  static readonly type = '[TyreOffer] DisposeSearch';
  constructor() { }
}

export class GetPreviewList {
  static readonly type = '[TyreOffer] Preview List';
  constructor(public Search: TyreOfferSearchModel) { }
}
